import { NotificationsService } from './notifications.service';
import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { StorageService } from './storage.service';
import { AppSettings } from './../app.settings';
import { environment } from 'environments/environment';
@Injectable()
export class AuthenticationValidationService  {

  constructor(private storageService: StorageService, private router: Router, private notificationService: NotificationsService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.storageService.getItemFromCookies(AppSettings.TOKEN_KEY)) {
      this.notificationService.canFetchNotification = true;
      return true;
    }
    this.router.navigate(['/signin']);
    // window.location.href = environment.loginUrl;
    this.notificationService.canFetchNotification = false;
    return false;
  }
}
